import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useAchievementStatus, useUpdatePrivacy } from '../../features/achievement';
import UsageTracker from '../../utils/UsageTracker';
import { useTrack } from '../../features/tracks';
import { jsx as _jsx } from "react/jsx-runtime";
const AwardVisibilityToggle = ({
  onToggle,
  checked,
  disabled
}) => {
  const onChange = useCallback(({
    target: {
      checked: _checked
    }
  }) => {
    onToggle(!!_checked);
  }, [onToggle]);
  return /*#__PURE__*/_jsx(Toggle, {
    checked: checked,
    "data-test-id": "award-visibility-toggle",
    disabled: disabled,
    onChange: onChange,
    size: "small"
  });
};
const AwardVisibilityToggleContainer = ({
  award,
  disabledTooltip,
  isFetchingAchievements,
  trackId,
  language
}) => {
  const {
    track,
    trackLoading
  } = useTrack(parseInt(trackId, 10), language);
  const {
    updatePrivacy,
    updatePrivacyLoading
  } = useUpdatePrivacy({
    trackId,
    awardCode: award.code,
    shouldBePublic: award.visibility !== 'PUBLIC'
  });
  const {
    isPrivate
  } = useAchievementStatus(trackId);
  const onToggle = useCallback(shouldBePublic => {
    const privacy = shouldBePublic ? 'PUBLIC' : 'PRIVATE';
    updatePrivacy();
    UsageTracker.track('awardInteraction', {
      action: 'toggle-privacy',
      privacy,
      awardCode: award && award.code,
      trackName: track && track.name,
      trackId
    });
  }, [award, track, trackId, updatePrivacy]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: isPrivate ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: disabledTooltip
    }) : null,
    children: /*#__PURE__*/_jsx("div", {
      "data-loading": updatePrivacyLoading || isFetchingAchievements || trackLoading,
      children: /*#__PURE__*/_jsx(AwardVisibilityToggle, {
        checked: !isPrivate,
        disabled: updatePrivacyLoading || isFetchingAchievements,
        onToggle: onToggle
      })
    })
  });
};
export default AwardVisibilityToggleContainer;